import setDefaultOptions from 'date-fns/setDefaultOptions'
import tr from 'date-fns/locale/tr'

export default function dateFnsOptions() {
  return setDefaultOptions({ locale: tr })
}
